import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCardsText, IDiscoveryProcessSection } from '../../discovery.state';
import style from './index.module.scss'

interface IDiscoveryProcessSectionProps {
    section: IDiscoveryProcessSection;
}

const DiscoveryProcessSectionComponent = ({section}: IDiscoveryProcessSectionProps) => {
    return(
        <section className={`${template.section} ${template.section__block_light}`}>
                <div className={template.container}>
                    <h2 className={template.steps__title}>
                        {section.title}
                    </h2>
                    <div className={template.specialists__items}>
                        {
                            section.cards.map((item: IDiscoveryCardsText, index: number) => {
                                return (
                                    <div key={index} className={template.specialists__item}>
                                        <div className={template.specialists__title}>
                                            {item.title}
                                        </div>
                                        <div className={template.specialists__text}>
                                            {item.text}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
    )
}

export default DiscoveryProcessSectionComponent;